export const getCookie = (key, parse = false) => {
	if (!key) return;
	try {
		const cookie = document.cookie
			.split("; ")
			.find((row) => row.split("=")[0] === key);
		let cookieValue = cookie ? cookie.split("=")[1] : "";
		if (parse && cookieValue) {
			return JSON.parse(decodeURIComponent(cookieValue));
		}
		return cookieValue;
	} catch (error) {
		console.error(error);
	}
};
